// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import vClickOutside from 'v-click-outside'

import App from './App'
import VueAuthenticate from 'vue-authenticate'
import router from '@/router'
import store from '@/store'
import { CHECK_AUTH } from '@/store/actions.type'

import ApiService from '@/common/api.service'
import ErrorFilter from '@/common/error.filter'

// Plugins - css + library imports
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import 'font-awesome/css/font-awesome.css';
import '@/assets/scss/_variables.scss'
import '@/assets/scss/custom.scss'
import 'es6-promise/auto'

// plugin setup
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'

import GSignInButton from 'vue-google-signin-button'
Vue.use(GSignInButton)

// configure language
locale.use(lang)

Vue.config.productionTip = false
Vue.filter('error', ErrorFilter)

Vue.use(ElementUI)

Vue.config.productionTip = false

ApiService.init()

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.auth.isAuthenticated) {
      next({
        path: '/Login',
        query: { replace: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
var vm = new Vue({
  el: '#app',
  router,
  store,
  GSignInButton,
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js